export const mobileNumberRegex = /^\d{10,15}$/;

export const pacCodeRegex = /^[A-Za-z]{3}\d{6}$/;
